import { useState, useEffect } from 'react';

export default function useLocalStorage(key, defaultValue) {

  // https://designcode.io/react-hooks-handbook-uselocalstorage-hook
  // WE change persistence from localStorage to sessionStorage because we need clear on close browser.

  const [value, setValue] = useState(() => {
    let currentValue;
    try {
      currentValue = JSON.parse(
        sessionStorage.getItem(key) || String(defaultValue)
      );
    } catch (error) {
      currentValue = defaultValue;
    }
    return currentValue;
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue];

}
